import { render, staticRenderFns } from "./FilterClicks.vue?vue&type=template&id=dfefc194&"
import script from "./FilterClicks.vue?vue&type=script&lang=js&"
export * from "./FilterClicks.vue?vue&type=script&lang=js&"
import style0 from "./FilterClicks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports